<div class="container">
	<div class="login-body">
		<div id="header-logo">
			<div class="login-section">
				<img *ngIf="pageDetails?.ibpLogoPath" class="login-logo" [src]="pageDetails?.ibpLogoPath" alt="Logo"/>
				<img *ngIf="pageDetails?.existsInstituteLogo" class="institute-logo" [src]="pageDetails?.instituteLogoPath" alt="Institute"/>
			</div>
		</div>
		<form class="js-login-form login-form" (keyup.enter)="submitLoginForm()">
			<div class="login-forgot-password-email-notify pb-3" *ngIf="this.email_sent === 'Y'" jhiTranslate="login.password.forgot.link.sent">
				If the email exists, BMS has sent you a link to update your password. If you don't receive it within a few minutes, please check your spam folder.
			</div>

			<div class="login-form-control" [ngClass]="{ 'login-validation-error': this.errorFields.includes('username') }">
				<span class="login-icon fa" title="{{ 'login.username.title' | translate}}">&#xf06c;</span>
				<input class="js-login-username login-input login-flat-control" name="username" placeholder="{{ 'login.username.title' | translate}}" type="text"
					   [(ngModel)]="model.username" />
			</div>
			<div class="login-form-control" [ngClass]="{ 'login-validation-error': this.errorFields.includes('password') }">
				<span class="login-icon fa login-icon" title="{{ 'login.password.title' | translate}}">&#xf084;</span>
				<input class="js-login-password login-input login-flat-control" name="password" placeholder="{{ 'login.password.title' | translate}}" type="password"
					   [(ngModel)]="model.password" />
			</div>

			<div class="login-form-control login-grid">
				<div class="js-login-checkbox-control login-input-inline login-checkbox-control" (click)="toggleRememberMe()">
					<!-- Value of remember me should be on or off -->
					<input class="js-login-checkbox-input login-checkbox-input" checked="checked" name="remember-me" type="checkbox" [(ngModel)]="model.rememberMe" [value]="'on'" (ngModelChange)="model.rememberMe = $event ? 'on' : 'off'" />
					<button class="js-login-remember-me ac-login-remember-me login-checkbox login-clickable" type="button">
						<span class="js-login-check fa" [ngClass]="{ 'fa-check': this.model.rememberMe === 'on' }"></span>
					</button
					><span class="js-login-remember-me login-checkbox-label" jhiTranslate="login.link.remember.me">Remember Me</span>
				</div>
				<div class="login-input-inline login-input-right">
				</div>
			</div>

			<div *ngIf="!this.isLoginFormValid" class="js-login-error">
				<span class="fa login-warning-icon">&#xf12a;</span>
				<span class="js-login-error-text">{{this.errorMessage}}</span>
			</div>

			<button class="js-login-submit login-submit login-flat-control login-clickable" formnovalidate="" type="button"
					[disabled]="isLoading" (click)="submitLoginForm()" [ngClass]="{ 'loading': isLoading }">
				<span *ngIf="isLoading" class="throbber throbber-btn"></span>
				<span class="login-submit-label" jhiTranslate="login.form.button">Sign In</span>
			</button>

			<div id="resetPasswordSection">
				<hr/>
				<p><span jhiTranslate="login.message.trouble.signing.in">Trouble signing in? </span></p>
				<button class="ac-login-forgot-password login-flat-control" type="button" (click)="goToForgotPassword()">
					<span class="login-submit-label" jhiTranslate="login.reset.button">Reset Password</span>
				</button>
			</div>
		</form>

		<div id="message">
			<div *ngIf="pageDetails != null && pageDetails.footerMessage != ''">
				<div [textContent]="pageDetails.footerMessage" class="login-footer-message">
				</div>
			</div>
		</div>

		<div id="footer">
			<div class="login-footer">
				<img *ngIf="pageDetails?.ibpLogoPath" class="login-footer-logo" [src]="pageDetails?.ibpLogoPath" alt="Logo"/>
				<div class="login-footer-body">
					<span jhiTranslate="about.version.prefix"></span><span data-test="bms-version" [innerText]="version"></span> &bull;
					{{'login.provider.message' | translate}} <a href="https://www.integratedbreeding.net/" jhiTranslate="login.provider.ibp">Integrated Breeding Platform</a>
                </div>
			</div>
            <jhi-languange-selector></jhi-languange-selector>
		</div>

	</div>
</div>
